import { TableCell, TableRow } from "@mui/material";
import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { AccessControl, CheckboxMui, FramerTooltip } from "@ryde/controls";
import {
  BookingCellId,
  getBookingCalendarCellId,
  IApprovalBookingConflict,
  IWithinProductionLockAdditional,
  NO_VALUE_DISPLAY,
} from "@ryde/shared";
import { orangeMui } from "@ryde/theme";

import { RejectedBookingPassengerTableCell } from "./rejected-booking-passenger-table-cell";

interface IRejectedBookingsWithinProductionLockRowProps {
  conflictRow: IApprovalBookingConflict;
  handleCheckboxChange?: (cellId: BookingCellId) => void;
  checked?: boolean;
  isLoading: boolean;
}

export const RejectedBookingsWithinProductionLockRow: FC<
  IRejectedBookingsWithinProductionLockRowProps
> = ({ handleCheckboxChange, checked = false, conflictRow, isLoading }) => {
  const direction = (
    conflictRow?.errorAdditional as IWithinProductionLockAdditional
  )?.direction;

  const cellId = getBookingCalendarCellId(
    Number(conflictRow.passengerId),
    conflictRow.date,
  );

  return (
    <TableRow>
      <AccessControl
        entity="booking"
        action="approve_conflict_within_production_lock"
      >
        {handleCheckboxChange && !isLoading && (
          <TableCell>
            <CheckboxMui
              checked={checked}
              onCheckboxToggle={() => handleCheckboxChange(cellId)}
            />
          </TableCell>
        )}
      </AccessControl>
      <TableCell>{conflictRow.passengerId}</TableCell>
      <RejectedBookingPassengerTableCell passengerId={conflictRow.passengerId}>
        <FramerTooltip content={conflictRow.passengerFullName}>
          <span
            data-e2e="passenger-cell"
            style={{ maxWidth: "100px" }}
            className="truncate-text"
          >
            {conflictRow.passengerFullName}
          </span>
        </FramerTooltip>
      </RejectedBookingPassengerTableCell>
      <TableCell>{conflictRow?.date}</TableCell>
      <TableCell>{direction ?? NO_VALUE_DISPLAY}</TableCell>
      <AccessControl
        entity="booking"
        action="approve_conflict_within_production_lock"
      >
        <TableCell align="center">
          {checked ? (
            <SVG_MUI.CircleCheck5SVG />
          ) : (
            <SVG_MUI.CircleExclamation color={orangeMui.A400} />
          )}
        </TableCell>
      </AccessControl>
    </TableRow>
  );
};
